import { GetUserPostsFilterRequest } from '@/shared/types/post/requests/GetUserPostsFilterRequest'

import { Post } from '../feed/get-post-by-id'
import { axios, Response } from '../index'

const getGroupFeed = ({
  filterRequest,
  groupId,
  isPinned,
  page,
  size
}: {
  filterRequest?: GetUserPostsFilterRequest
  groupId: string
  isPinned?: boolean
  page?: number
  size?: number
}): Response<Post[]> => {
  const searchParams = [
    `isPinned=${isPinned ?? false}`,
    typeof page === 'number' ? `page=${page}` : undefined,
    typeof size === 'number' ? `size=${size}` : undefined
  ]

  if (filterRequest) {
    const filterRequestRecordStringAndString =
      filterRequest as unknown as Record<string, string>

    for (const [key, value] of Object.entries(
      filterRequestRecordStringAndString
    )) {
      if (value !== undefined && key !== undefined) {
        searchParams.push(`${key}=${value.toString()}`)
      }
    }
  }

  return axios.get(
    `/v2/groups/${groupId}/posts?${searchParams
      .filter((d): d is string => !!d)
      .join('&')}`
  )
}

export default getGroupFeed
